import { Comment } from "./types";

export const formatTime = (timeInSeconds: number): string => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

// The backend requires comment text, so a comment that is only a drawing is saved with this.
export const DRAWING_PLACEHOLDER = "Drawing";

export const isDrawingPlaceholder = (comment: Pick<Comment, "content" | "annotation">): boolean =>
    Boolean(comment.annotation?.strokes.length) && comment.content === DRAWING_PLACEHOLDER;
